<img
  loading="eager"
  [ngClass]="imageClassName"
  [src]="emojiSource"
  [alt]="altText"
/>
